module.exports = "<div fxLayout=\"row\">\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/header/header.component.html
// module id = ../../../../../src/app/pages/cerba/header/header.component.html
// module chunks = 1